/**
 * VibeCats — Utilitários
 *
 * Funções auxiliares reutilizáveis em todo o projeto.
 */

const Utils = (() => {
    'use strict';

    /**
     * Debounce — limita a taxa de chamada de uma função.
     * @param {Function} fn
     * @param {number} delay
     * @returns {Function}
     */
    function debounce(fn, delay = 100) {
        let timer = null;
        return function (...args) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    /**
     * Throttle — garante que uma função seja chamada no máximo uma vez por intervalo.
     * @param {Function} fn
     * @param {number} limit
     * @returns {Function}
     */
    function throttle(fn, limit = 100) {
        let inThrottle = false;
        return function (...args) {
            if (!inThrottle) {
                fn.apply(this, args);
                inThrottle = true;
                setTimeout(() => { inThrottle = false; }, limit);
            }
        };
    }

    /**
     * Verifica se o dispositivo é mobile/touch.
     * @returns {boolean}
     */
    function isMobile() {
        return window.innerWidth <= 768;
    }

    /**
     * Verifica se o dispositivo é tablet.
     * @returns {boolean}
     */
    function isTablet() {
        return window.innerWidth <= 1024;
    }

    /**
     * Verifica preferência por redução de movimento.
     * @returns {boolean}
     */
    function prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /**
     * Gera um número aleatório entre min e max.
     * @param {number} min
     * @param {number} max
     * @returns {number}
     */
    function randomBetween(min, max) {
        return Math.random() * (max - min) + min;
    }

    /**
     * Converte graus para radianos.
     * @param {number} degrees
     * @returns {number}
     */
    function degToRad(degrees) {
        return degrees * (Math.PI / 180);
    }

    /**
     * Calcula a posição de um elemento relativa ao viewport.
     * @param {HTMLElement} el
     * @returns {DOMRect}
     */
    function getOffset(el) {
        return el.getBoundingClientRect();
    }

    /**
     * Espera um número de milissegundos (para uso com async/await).
     * @param {number} ms
     * @returns {Promise<void>}
     */
    function wait(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    return {
        debounce,
        throttle,
        isMobile,
        isTablet,
        prefersReducedMotion,
        randomBetween,
        degToRad,
        getOffset,
        wait,
    };
})();
